import Renderer from "@FreeRider/Renderers/Renderer";
import MountainBike from '@FreeRider/Player/Vehicles/MountainBike';
import Camera from '@FreeRider/Camera';
import Screen from '@FreeRider/Screen';
import Player from '@FreeRider/Player/Player';
import RagdollRenderer from '@FreeRider/Renderers/RagdollRenderer';

class MountainBikeRenderer extends Renderer
{
    private ragdollRenderer: RagdollRenderer;

    constructor(canvas)
    {
        super(canvas);

        this.ragdollRenderer = new RagdollRenderer(canvas);
    }

    public render(player: Player, camera: Camera, screen: Screen)
    {
        const mountainBike = player.vehicle as MountainBike;

        const canvas = this.canvas;

        const canvasCtx = this.canvasCtx;

        const screenCenterX = screen.width / 2;
        const screenCenterY = screen.height / 2;

        let direction = mountainBike.dir;

        let zoom = camera.zoom;

        let frontWheel = mountainBike.getFrontWheel();
        let rearWheel = mountainBike.getRearWheel();
        let head = mountainBike.getHead();

        let frontWheelPosition = frontWheel.position;
        let rearWheelPosition = rearWheel.position;
        let head_position = head.position;

        const fwX = (frontWheelPosition.x - camera.x) * camera.zoom + screenCenterX;
        const fwY = (frontWheelPosition.y - camera.y) * camera.zoom + screenCenterY;

        const rwX = (rearWheelPosition.x - camera.x) * camera.zoom + screenCenterX;
        const rwY = (rearWheelPosition.y - camera.y) * camera.zoom + screenCenterY;

        const hX = (head_position.x - camera.x) * camera.zoom + screenCenterX;
        const hY = (head_position.y - camera.y) * camera.zoom + screenCenterY;

        let pX = fwX - rwX;
        let pY = fwY - rwY;

        let nX = (fwY - rwY) * direction;
        let nY = (rwX - fwX) * direction;

        let n2X = pX * 0.5;
        let n2Y = pY * 0.5;

        n2X = rwX + n2X;
        n2Y = rwY + n2Y;

        n2X = hX - n2X;
        n2Y = hY - n2Y;

        //Base Styles
        canvasCtx.strokeStyle = '#000000';
        canvasCtx.lineWidth = 3 * zoom;
        canvasCtx.lineCap = 'round';
        canvasCtx.lineJoin = 'round';
        canvasCtx.fillStyle = 'rgba(200,200,200,0.2)';

        //Front Wheel
        canvasCtx.beginPath();
        canvasCtx.arc(fwX, fwY, (frontWheel.radius - 2) * zoom, 0, 2 * Math.PI, false);
        canvasCtx.fill();
        canvasCtx.stroke();

        //Rear Wheel
        canvasCtx.beginPath();
        canvasCtx.arc(rwX, rwY, (frontWheel.radius - 2) * zoom, 0, 2 * Math.PI, false);
        canvasCtx.fill();
        canvasCtx.stroke();

        //Inner Wheel Styles
        canvasCtx.strokeStyle = '#999999';
        canvasCtx.fillStyle = '#CCCCCC';
        canvasCtx.lineWidth = 1 * zoom;

        //Inner Front Wheel
        canvasCtx.beginPath();
        canvasCtx.arc(fwX, fwY, 6 * zoom, 0, 2 * Math.PI, false);
        canvasCtx.fill();
        canvasCtx.stroke();

        //Inner Rear Wheel
        canvasCtx.beginPath();
        canvasCtx.arc(rwX, rwY, 6 * zoom, 0, 2 * Math.PI, false);
        canvasCtx.fill();
        canvasCtx.stroke();

        //Bike Frame Styles
        canvasCtx.beginPath();
        canvasCtx.strokeStyle = '#000000';
        canvasCtx.lineWidth = 5 * zoom;

        //Bike Frame
        canvasCtx.moveTo(rwX, rwY);
        canvasCtx.lineTo(rwX + pX * 0.4 + nX * 0.05, rwY + pY * 0.4 + nY * 0.05);
        canvasCtx.moveTo(rwX + pX * 0.72 + n2X * 0.64, rwY + pY * 0.72 + n2Y * 0.64);
        canvasCtx.lineTo(rwX + pX * 0.46 + n2X * 0.4, rwY + pY * 0.46 + n2Y * 0.4);
        canvasCtx.lineTo(rwX + pX * 0.4 + nX * 0.05, rwY + pY * 0.4 + nY * 0.05);
        canvasCtx.stroke();

        //Bike Frame bottom style
        canvasCtx.beginPath();
        canvasCtx.lineWidth = 2 * zoom;
        canvasCtx.strokeStyle = '#000000';

        //Bike Frame bottom
        canvasCtx.moveTo(rwX + pX * 0.72 + n2X * 0.64, rwY + pY * 0.72 + n2Y * 0.64);
        canvasCtx.lineTo(rwX + pX * 0.43 + nX * 0.05, rwY + pY * 0.43 + nY * 0.05);
        canvasCtx.stroke();

        //Seat Post - thin
        canvasCtx.beginPath();
        canvasCtx.lineWidth = 1 * zoom;
        canvasCtx.moveTo(rwX + pX * 0.46 + n2X * 0.4, rwY + pY * 0.46 + n2Y * 0.4);
        canvasCtx.lineTo(rwX + pX * 0.28 + n2X * 0.5, rwY + pY * 0.28 + n2Y * 0.5);
        canvasCtx.stroke();

        //Seat Post - thick
        canvasCtx.beginPath();
        canvasCtx.lineWidth = 2 * zoom;
        canvasCtx.moveTo(rwX + pX * 0.45 + n2X * 0.3, rwY + pY * 0.45 + n2Y * 0.3);
        canvasCtx.lineTo(rwX + pX * 0.3 + n2X * 0.4, rwY + pY * 0.3 + n2Y * 0.4);
        canvasCtx.lineTo(rwX + pX * 0.25 + n2X * 0.6, rwY + pY * 0.25 + n2Y * 0.6);
        canvasCtx.moveTo(rwX + pX * 0.17 + n2X * 0.6, rwY + pY * 0.17 + n2Y * 0.6);
        canvasCtx.lineTo(rwX + pX * 0.3 + n2X * 0.6, rwY + pY * 0.3 + n2Y * 0.6);
        canvasCtx.stroke();

        //Front Shocks / Fork
        canvasCtx.beginPath();
        canvasCtx.lineWidth = 3 * zoom;
        canvasCtx.moveTo(fwX, fwY);
        canvasCtx.lineTo(rwX + pX * 0.71 + n2X * 0.73, rwY + pY * 0.71 + n2Y * 0.73);
        canvasCtx.lineTo(rwX + pX * 0.73 + n2X * 0.77, rwY + pY * 0.73 + n2Y * 0.77);
        canvasCtx.lineTo(rwX + pX * 0.7 + n2X * 0.8, rwY + pY * 0.7 + n2Y * 0.8);
        canvasCtx.stroke();

        //Pedal
        const pedala = mountainBike.pedala;
        const offX = 6 * Math.cos(pedala) * zoom;
        const offY = 6 * Math.sin(pedala) * zoom;

        canvasCtx.beginPath();
        canvasCtx.lineWidth = 1 * zoom;
        canvasCtx.moveTo(rwX + pX * 0.43 + nX * 0.05 + offX, rwY + pY * 0.43 + nY * 0.05 + offY);
        canvasCtx.lineTo(rwX + pX * 0.43 + nX * 0.05 - offX, rwY + pY * 0.43 + nY * 0.05 - offY);
        canvasCtx.stroke();

        if (player.isAlive === true)
        {
            nX = pX * 0.5;
            nY = pY * 0.5;
            nX = rwX + nX;
            nY = rwY + nY;
            nX = hX - nX;
            nY = hY - nY;

            let m1X = pX * 0.3;
            let m1Y = pY * 0.3;
            m1X = (rwX + m1X) + (nX * 0.25);
            m1Y = (rwY + m1Y) + (nY * 0.25);

            let m2X = pX * 0.4;
            let m2Y = pY * 0.4;
            m2X = (rwX + m2X) + (nX * 0.05);
            m2Y = (rwY + m2Y) + (nY * 0.05);

            const pedal1X = m2X + offX;
            const pedal1Y = m2Y + offY;
            const pedal2X = m2X - offX;
            const pedal2Y = m2Y - offY;

            let handX = (pX * 0.67);
            let handY = (pY * 0.67);
            handX = (rwX + handX) + (nX * 0.8);
            handY = (rwY + handY) + (nY * 0.8);

            let hipX = (pX * -0.05);
            let hipY = (pY * -0.05);
            hipX = (m1X + hipX) + (nX * 0.42);
            hipY = (m1Y + hipY) + (nY * 0.42);

            let p2X = pedal1X - hipX;
            let p2Y = pedal1Y - hipY;

            let p2Lensqr = Math.pow(p2X, 2) + Math.pow(p2Y, 2);

            let zoomZoom = zoom * zoom;

            n2X = (p2Y * direction);
            n2Y = (-p2X * direction);
            n2X = n2X * zoomZoom;
            n2Y = n2Y * zoomZoom;

            let knee1X = (p2X * 0.5);
            let knee1Y = (p2Y * 0.5);
            knee1X = (hipX + knee1X) + (n2X * (200 / p2Lensqr));
            knee1Y = (hipY + knee1Y) + (n2Y * (200 / p2Lensqr));

            let foot1X = (p2X * 0.12);
            let foot1Y = (p2Y * 0.12);
            foot1X = (pedal1X + foot1X) + (n2X * (50 / p2Lensqr));
            foot1Y = (pedal1Y + foot1Y) + (n2Y * (50 / p2Lensqr));

            p2X = pedal2X - hipX;
            p2Y = pedal2Y - hipY;

            p2Lensqr = Math.pow(p2X, 2) + Math.pow(p2Y, 2);

            n2X = (p2Y * direction) * zoomZoom;
            n2Y = (-p2X * direction) * zoomZoom;

            let knee2X = p2X * 0.5;
            let knee2Y = p2Y * 0.5;
            knee2X = (hipX + knee2X) + (n2X * (200 / p2Lensqr));
            knee2Y = (hipY + knee2Y) + (n2Y * (200 / p2Lensqr));

            let foot2X = p2X * 0.12;
            let foot2Y = p2Y * 0.12;
            foot2X = (pedal2X + foot2X) + (n2X * (50 / p2Lensqr));
            foot2Y = (pedal2Y + foot2Y) + (n2Y * (50 / p2Lensqr));

            //Background leg
            canvasCtx.strokeStyle = 'rgba(0,0,0,0.5)';
            canvasCtx.lineWidth = 6 * zoom;
            canvasCtx.beginPath();
            canvasCtx.moveTo(pedal2X, pedal2Y);
            canvasCtx.lineTo(knee2X, knee2Y);
            canvasCtx.lineTo(hipX, hipY);
            canvasCtx.stroke();

            //Background foot
            canvasCtx.lineWidth = 4 * zoom;
            canvasCtx.beginPath();
            canvasCtx.moveTo(pedal2X, pedal2Y);
            canvasCtx.lineTo(foot2X, foot2Y);
            canvasCtx.stroke();

            //Foreground leg
            canvasCtx.lineWidth = 6 * zoom;
            canvasCtx.strokeStyle = '#000000';
            canvasCtx.beginPath();
            canvasCtx.moveTo(pedal1X, pedal1Y);
            canvasCtx.lineTo(knee1X, knee1Y);
            canvasCtx.lineTo(hipX, hipY);
            canvasCtx.stroke();

            //Foreground foot
            canvasCtx.lineWidth = 4 * zoom;
            canvasCtx.beginPath();
            canvasCtx.moveTo(pedal1X, pedal1Y);
            canvasCtx.lineTo(foot1X, foot1Y);
            canvasCtx.stroke();

            //Shoulder Point
            let shoulderX = pX * 0.1;
            let shoulderY = pY * 0.1;
            shoulderX = (m1X + shoulderX) + (nX * 0.95);
            shoulderY = (m1Y + shoulderY) + (nY * 0.95);

            //Waist
            canvasCtx.lineWidth = 8 * zoom;
            canvasCtx.beginPath();
            canvasCtx.moveTo(hipX, hipY);
            canvasCtx.lineTo(shoulderX, shoulderY);
            canvasCtx.stroke();


            //Head
            let headX = pX * 0.2;
            let headY = pY * 0.2;
            headX = (m1X + headX) + (nX * 1.09);
            headY = (m1Y + headY) + (nY * 1.09);

            //Arm to Hands
            pX = shoulderX - handX;
            pY = shoulderY - handY;

            const pLensqr = Math.pow(pX, 2) + Math.pow(pY, 2);

            nX = (pY * direction);
            nY = (-pX * direction);
            nX = nX * zoomZoom;
            nY = nY * zoomZoom;

            let elbowX = pX * 0.3;
            let elbowY = pY * 0.3;
            elbowX = (handX + elbowX) + (nX * (80 / pLensqr));
            elbowY = (handY + elbowY) + (nY * (80 / pLensqr));

            canvasCtx.lineWidth = 5 * zoom;
            canvasCtx.beginPath();
            canvasCtx.moveTo(shoulderX, shoulderY);
            canvasCtx.lineTo(elbowX, elbowY);
            canvasCtx.lineTo(handX, handY);
            canvasCtx.stroke();


            //Draw Head
            let p1 = frontWheelPosition;
            let p2 = rearWheelPosition;

            const p1X = p1.x;
            const p1Y = p1.y;
            p2X = p2.x;
            p2Y = p2.y;

            let diffX = p1X - p2X;
            let diffY = p1Y - p2Y;

            let drawHeadAngle = -(Math.atan2(diffX, diffY) - (Math.PI / 2));

            let playerHead = player.head;

            let playerHeadWidth = playerHead.width;
            let playerHeadHeight = playerHead.height;
            let playerHeadScale = playerHead.scale;
            let playerHeadOffsetX = playerHead.offsetX;
            let playerHeadOffsetY = playerHead.offsetY;

            playerHeadWidth = playerHeadWidth * zoom * playerHeadScale;
            playerHeadHeight = playerHeadHeight * zoom * playerHeadScale;

            playerHeadOffsetX = (playerHeadOffsetX * zoom) - (playerHeadWidth / 2);
            playerHeadOffsetY = (playerHeadOffsetY * zoom) - (playerHeadHeight / 2);

            const playerCanvas = playerHead.getCanvas(zoom);

            canvasCtx.translate(headX, headY);
            canvasCtx.rotate(drawHeadAngle);

            if (direction < 0)
            {
                canvasCtx.scale(1, -1);
            }

            canvasCtx.drawImage(playerCanvas, playerHeadOffsetX, playerHeadOffsetY, playerHeadWidth, playerHeadHeight);
            if (direction < 0)
            {
                canvasCtx.scale(1, -1);
            }

            canvasCtx.rotate(-drawHeadAngle);
            canvasCtx.translate(-headX, -headY);
        }
        else
        {
            this.ragdollRenderer.render(player, mountainBike.ragdoll, screen, camera);
        }
    }
}

export default MountainBikeRenderer;